import template from './uc-free-products-page.html.twig';
import './uc-free-products-page.scss';

// Vendor+plugin-prefixed name — see the matching comment in
// components/uc-element-sorter/index.js for why (global registry collision).
Shopware.Component.register('sellops-uc-free-products-page', {
    template,

    methods: {
        goToConfig() {
            this.$router.push({ name: 'sellops.ultimate.cart.config' });
        },
    },
});
